import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { UiRouteLinks } from '@lsq-frontend/angular-shared/app-constants';
import { UserService } from '@lsq-frontend/angular-shared/features/user-service';
import { UnImpersonateUserService } from '@lsq-frontend/remote-services/enterprise/dashboard-services';
import { first } from 'rxjs/operators';

@Injectable()
export class UnImpersonateGuard implements CanActivate {
    constructor(
        private _userService: UserService,
        private _router: Router,
        private _unImpersonateUserService: UnImpersonateUserService
    ) {}

    public async canActivate(): Promise<true | UrlTree> {
        const user = await this._userService.user$.pipe(first()).toPromise();
        return !user.isImpersonating || (await this._unImpersonateUser());
    }

    private async _unImpersonateUser(): Promise<true | UrlTree> {
        try {
            await this._unImpersonateUserService.executeOnce();
            await this._userService.getAndEmitCurrentUser();
            return true;
        } catch {
            return this._router.parseUrl(`/${UiRouteLinks.NotFound}`);
        }
    }
}
